export default "__VITE_ASSET__B4z7QSzY__"